export const formatCents = (number: number) => {
  const dollars = number / 100

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(dollars)
}
